import { FormGroup, FormControl, Validators, FormGroupDirective } from '@angular/forms';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rejection-reason',
  templateUrl: './rejection-reason.component.html',
  styleUrls: ['./rejection-reason.component.scss']
})
export class RejectionReasonComponent implements OnInit {
  @ViewChild('docRejectForm') docRejectForm: FormGroupDirective;
  @Input('quotationAction') quotationAction;
  @Input('quotationDetail') quotationDetail;
  submitted: boolean = false;
  rejectForm = new FormGroup({
    reason: new FormControl('', [Validators.required]),
  });

  constructor(
    public activeModal: NgbActiveModal,
    private el: ElementRef
  ) {
  }

  ngOnInit() {
    this.rejectForm.controls['reason'].setValue(this.quotationDetail.reason);
  }

  submit() {
    console.log(this.rejectForm)
    if (this.rejectForm.valid) {
      let fd: any = this.rejectForm.value;
      this.quotationAction.emit({ uuid: this.quotationDetail.uuid, action: 'reject', rejected_reason: fd.reason });
      this.activeModal.dismiss();
    }
  }

}
